import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import HorizontalRule from 'components/HorizontalRule';
import RatingDetailModal from './RatingDetailModal';

export const defaultStyleState = {
  positiveFeedback: false,
  negativeFeedback: false,
};

const RatingSection = props => {
  const [index, setIndex] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [styleState, setStyleState] = useState(defaultStyleState);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const { reviews } = props;
    setReviews(reviews);
  }, [props.reviews]);

  const openReviewModal = () => {
    setOpenModal(!openModal);
  };

  if (reviews.length === 0) return null;

  return (
    <>
      <HorizontalRule />
      <div className='rating-section col-md-5 col-xs-12 mb-2'>
        <div className='d-flex flex-row justify-content-between p-3'>
          <div className='d-flex'>
            <div><span className='text-danger'>{reviews.length}</span> Athletic Trainer{reviews.length === 1 ? '' : 's'} to review</div>
          </div>
          <button className='font-italic font-weight-bold review-ats' onClick={openReviewModal}>REVIEW ATs</button>
        </div>
        <RatingDetailModal
          isOpen={openModal}
          index={index}
          reviews={reviews}
          styleState={styleState}
          setIndex={setIndex}
          setStyleState={setStyleState}
          openReviewModal={openReviewModal}
        />
      </div>
      <HorizontalRule />
    </>
  )
}

export default RatingSection;
